import PropTypes from 'prop-types';
import {useSelector} from 'react-redux';
import {Maintenance} from 'front-onceforall-core';
import RegistrationMessage from './registrationMessage';
import Selector from './selector';
import SubcontractorsStats from './subcontractorsStats';
import InformationMessage from '../informationMessage';
import shouldShowStats from './utils/shouldShowStats';
import {pathResolver} from '../../utils/basePathHelper';

function GlobalDashboardView({loading}) {
  const [user, maintenance, currentLocale] = useSelector(state => [
    state.user,
    state.maintenance,
    state.i18n.locale
  ]);

  return (
    <>
      <RegistrationMessage/>

      <Maintenance
        class="mb-5"
        maintenance={maintenance}
        currentLocale={currentLocale}
      />

      <div className="row h-100">
        <div className="col-12 col-xl-6">
          <Selector loading={loading}/>
        </div>
        <div className="col-12 col-xl-6 pl-0">
          <InformationMessage/>
          {shouldShowStats(user.userOrganisations) ?
            <SubcontractorsStats loading={loading}/> : (
              <div className="row d-xl-flex h-100">
                <div className="col-12">
                  <img
                    alt="dossier overview"
                    // eslint-disable-next-line prefer-template
                    src={pathResolver('resources/svg/quitus.svg')}
                  />
                </div>
              </div>
            )}
        </div>
      </div>
    </>
  );
}

GlobalDashboardView.propTypes = {
  loading: PropTypes.bool
};

export default GlobalDashboardView;
